/**
 * Event and event properties naming convention:
 * - Start always with a capital letter.
 * - In case of multiple words, use spaces, so avoid using camelCase, kebab-case, snake_case, etc.
 * - Avoid using special characters like #, $, _, @.
*/
const ANALYTICS_EVENTS = {
  signUp: 'Signed up',
  pageView: 'Page viewed',
  fileUpload: 'File uploaded',
  unfoldExpenseActivity: 'Unfold Expense activity',
  addPurchaseOrder: 'Add Purchase Order',
  addExpense: 'Add Expense',
  editMarkup: 'Edit Markup',
  editSellingPrice: 'Edit Selling price',
  projectFileUpload: 'Project file upload'
}

const ANALYTICS_FIELDS = {
  teamId: 'Team ID',
  teamName: 'Team name',
  companySize: 'Company size',
  plannerEnabled: 'Planner enabled',
  roleType: 'Role type',
  functions: 'Functions',
  name: 'Name',
  email: 'Email',
  company: 'Company',
  type: 'Type',
  page: 'Page',
  size: 'Size'
}

module.exports = {
  ANALYTICS_EVENTS,
  ANALYTICS_FIELDS
}
